/**
 * This file exposes frequently used generator methods.
 *
 * These methods are auto-imported in components and pages and can be used
 * directly in templates, <script setup> or anywhere in the Options API without
 * having to manually import them.
 */

import { v4 as uuid } from 'uuid'

/**
 * Generates a Random UUID (Universally Unique Identifier).
 *
 * @returns The generated UUID.
 *
 * @example generateUuid() // "1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed"
 */
export function generateUuid() {
  return uuid()
}
